// src/components/ui/navigation/TabNavigation/TabNavigationShadcn.jsx
import React from 'react';

// shadcn components
import { Tabs, TabsList, TabsTrigger } from '../../tabs';
import { Badge } from '../../badge';

import { cn } from '../../../../utils/cn';

const TabNavigationShadcn = ({
  tabs = [],
  activeTab,
  onTabChange,
  className = ''
}) => {
  return (
    <div className={cn("mb-6", className)}>
      <Tabs value={activeTab} onValueChange={onTabChange}>
        <TabsList className="grid w-full grid-cols-4 h-auto p-1">
          {tabs.map((tab) => {
            const Icon = tab.icon;

            return (
              <TabsTrigger
                key={tab.id}
                value={tab.id}
                className="flex items-center gap-2 px-4 py-3 data-[state=active]:bg-primary/20 data-[state=active]:text-primary"
              >
                {Icon && <Icon className="w-4 h-4" />}
                <span className="font-medium">{tab.label}</span>
                {tab.count !== undefined && (
                  <Badge variant="secondary" className="ml-1 h-5 text-xs">
                    {tab.count}
                  </Badge>
                )}
              </TabsTrigger>
            );
          })}
        </TabsList>
      </Tabs>
    </div>
  );
};

export default TabNavigationShadcn;